import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export default function CountdownTimer({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState(calcTimeLeft());

  function calcTimeLeft() {
    const diff = new Date(targetDate) - new Date();
    if (diff <= 0) return { days: 0, hours: 0, mins: 0, secs: 0, expired: true };
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      mins: Math.floor((diff / (1000 * 60)) % 60),
      secs: Math.floor((diff / 1000) % 60),
      expired: false,
    };
  }

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calcTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, [targetDate]);

  if (timeLeft.expired) {
    return <span className="text-xs text-accent font-bold uppercase tracking-wider">LIVE NOW</span>;
  }

  return (
    <div className="flex items-center gap-1.5" data-testid="countdown-timer">
      <Clock className="w-3 h-3 text-muted-foreground" />
      <div className="flex items-center gap-1 font-mono text-xs">
        {timeLeft.days > 0 && (
          <span className="bg-muted/50 px-1.5 py-0.5 rounded-sm text-foreground">{timeLeft.days}d</span>
        )}
        <span className="bg-muted/50 px-1.5 py-0.5 rounded-sm text-foreground">{String(timeLeft.hours).padStart(2, '0')}h</span>
        <span className="bg-muted/50 px-1.5 py-0.5 rounded-sm text-foreground">{String(timeLeft.mins).padStart(2, '0')}m</span>
        <span className="bg-muted/50 px-1.5 py-0.5 rounded-sm text-primary">{String(timeLeft.secs).padStart(2, '0')}s</span>
      </div>
    </div>
  );
}
